export default __webpack_public_path__ + "static/0029-2f609ecf3f47a2f277c552cdc2a43c06.png";